import React, { useEffect, useState } from "react";
import useStore from "../Zustand/useStore";
import { groupDashboard } from "../../redux/api/dummyJson";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import PeopleIcon from "@mui/icons-material/People";
import BusinessIcon from "@mui/icons-material/Business";
import VideocamIcon from "@mui/icons-material/Videocam";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import FavoriteIcon from "@mui/icons-material/Favorite";

const GroupDashboard = () => {
  const user = useStore((state) => state.user);
  const [dashboardList, setDashboardList] = useState({});

  const getDashboard = () => {
    get(URL.USER_DASHBOARD)
      .then((res) => {
        if (res?.status == "success") {
          setDashboardList(res?.dashboard_datas);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getDashboard();
  }, []);

  return (
    <div className="dashRightView ">
      {user && (
        <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray mt-3">
          {`${user?.name} user`}
        </h4>
      )}
      {/* <hr className="border-t-2 border-gray-400 " /> */}
      <div className="d-flex flex-row flex-wrap gap-5 mt-3 pointer">
        <div className=" my-3 content-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              No of New Alerts
            </h4>
            <NotificationsActiveIcon
              style={{ color: "orange" }}
              fontSize="large"
            />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.new_alert_count}
          </h2>
        </div>
        <div className=" my-3 content-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              No of Allocated Alerts
            </h4>
            <AssignmentTurnedInIcon
              style={{ color: "blueviolet" }}
              fontSize="large"
            />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.allocated_alert_count}
          </h2>
        </div>
        <div className=" my-3 content-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              No of Closed Alerts
            </h4>
            <DoneAllIcon style={{ color: "green" }} fontSize="large" />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.closed_alert_count}
          </h2>
        </div>
        <div className=" my-3 content-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              Re-Assigned Alerts
            </h4>
            <DoneAllIcon style={{ color: "green" }} fontSize="large" />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.re_assigned_alert_count}
          </h2>
        </div>
      </div>
      <div className="d-flex ac-js gap-3 mt-5">
        <div className=" my-3 user-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              Device Status
            </h4>
            <FavoriteIcon
              className={dashboardList?.device_status ? "green" : "red"}
              style={{ fontSize: 30 }}
            />
          </div>
        </div>
        <div className=" my-3 user-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              Service Status
            </h4>
            <FavoriteIcon
              className={dashboardList?.service_status ? "green" : "red"}
              style={{ fontSize: 30 }}
            />
          </div>
        </div>
      </div>
      <div className=" my-3 user-dashboard" style={{ width: "350px" }}>
        <div className="d-flex flex-column gap-4">
          <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
            Description
          </h4>
          <textarea
            value={dashboardList?.service_error}
            readOnly
            className="input-box"
            style={{ backgroundColor: "#e9f0ff" }}
          />
        </div>
      </div>
    </div>
  );
};

export default GroupDashboard;
